import { publicAsset } from "./publicAsset.mjs";

// Also rewrite provider URLs restored from older browser sessions or bundled
// catalog metadata, so every poster uses the same origin as the website.
export function websitePosterUrl(url) {
  if (typeof url !== "string") return null;
  const match = url.match(/^https:\/\/image\.tmdb\.org\/t\/p\/(?:w\d+|original)(\/[A-Za-z0-9_-]+\.(?:jpg|png|webp))$/i);
  return match ? publicAsset(`media/posters${match[1]}`) : url;
}
